
export const dateFormat = (dateData) => {

    var date = new Date(dateData);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    const time = y + "-" + m + "-" + d;
    return time;

}
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
      date = time;
    } else {
      if ((typeof time === "string") && (/^[0-9]+$/.test(time))) {
        time = parseInt(time);
      }
      if ((typeof time === "number") && (time.toString().length === 10)) {
        time = time * 1000;
      }
      date = new Date(time);
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    };
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key];
      // Note: getDay() returns 0 on Sunday
      if (key === "a") { return ["日", "一", "二", "三", "四", "五", "六"][value]; }
      return value.toString().padStart(2, "0");
    });
    return time_str;
  }
  
  /**
   * @param {number} time
   * @param {string} option
   * @returns {string}
   */
  export function formatTime(time, option) {
    if (("" + time).length === 10) {
      time = parseInt(time) * 1000;
    } else {
      time = +time;
    }
    const d = new Date(time);
    const now = Date.now();
  
    const diff = (now - d) / 1000;
  
    if (diff < 30) {
      return "刚刚";
    } else if (diff < 3600) {
      // less 1 hour
      return Math.ceil(diff / 60) + "分钟前";
    } else if (diff < 3600 * 24) {
      return Math.ceil(diff / 3600) + "小时前";
    } else if (diff < 3600 * 24 * 2) {
      return "1天前";
    }
    if (option) {
      return parseTime(time, option);
    } else {
      return (
        d.getMonth() +
        1 +
        "月" +
        d.getDate() +
        "日" +
        d.getHours() +
        "时" +
        d.getMinutes() +
        "分"
      );
    }
  }
  export function FormatDate (strTime) {
    var date = new Date(strTime);
    return date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
}
// export function millisToMinutes(millis) {
//   var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
//   var minutes = Math.floor(millis / 60000);
//   // var seconds = ((millis % 60000) / 1000).toFixed(0);
//   return minutes + ":" + (seconds < 10 ? '0' : '');
// }
   // 拆分时间位数的函数----hh拆成 h  h
export function splitTime(time) {
  var str1,str2,str;
  var len = time.toString().length;
  if(len === 2) {
    str1 = time.toString().slice(0,1)
    str2 = time.toString().slice(1)
    str = '<span>' + str1 + '</span><span>' + str2 + '</span>'
  }
  return str
}

// 把时间戳转成时间格式
export function transTime(t) {
  // var d = parseInt(t / (1000 * 60 * 60 * 24))
  // var h = parseInt(t % (1000 * 60 * 60 * 24) / (1000 * 60 * 60))
  var m = parseInt(t % (1000 * 60 * 60 * 24) % (1000 * 60 * 60) / (1000 * 60))
  // var s = parseInt(t % (1000 * 60 * 60 * 24) % (1000 * 60 * 60) % (1000 * 60) / 1000)
  // d = d < 10 ? '0' + d : d;
  // h = h < 10 ? '0' + h : h;
  m = m < 10 ? '0' + m : m;
  // s = s < 10 ? '0' + s : s;  
  // var dd = splitTime(d);
  // var hh = splitTime(h);
  var mm = splitTime(m);
  // var ss = splitTime(s);
  return  m 
}
// JS计算两个日期时间差，天 小时 分 秒格式
export function diffTime(startDate,endDate) { 
  startDate= new Date(startDate);
  endDate = new Date(endDate);
  var diff=endDate.getTime() - startDate.getTime();//时间差的毫秒数
 
  //计算出相差天数
  var days=Math.floor(diff/(24*3600*1000)); 
      
  //计算出小时数
  var leave1=diff%(24*3600*1000);    //计算天数后剩余的毫秒数
  var hours=Math.floor(leave1/(3600*1000)); 
  //计算相差分钟数
  var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数
  var minutes=Math.floor(leave2/(60*1000)); 
      
  //计算相差秒数
  var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数
  var seconds=Math.round(leave3/1000); 
     
  var returnStr = seconds + "秒"; 
  if(minutes>0) { 
      returnStr = minutes + "分" + returnStr; 
  } 
  if(hours>0) { 
      returnStr = hours + "小时" + returnStr; 
  } 
  if(days>0) { 
      returnStr = days + "天" + returnStr; 
  } 
  return returnStr; 
}
export function dateFunction(time){
	var zoneDate = new Date(time).toJSON();
	var date = new Date(+new Date(zoneDate)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'');
	return date;
}